import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Rendered in place of a normal row when a rule references a field that no
 * longer exists in the schema (after rename/delete). Red-tinted, disabled,
 * offers Replace-with... picker + Remove. Save is blocked until all ghost
 * rows are resolved (validateRules emits dangling_field errors for them).
 */
export default function DanglingRefRow({
	scope,
	ruleIndex,
	condIndex,
	missingName,
	compatibleFields,
	onReplace,
	onRemove,
}) {
	const [picker, setPicker] = useState('');
	const testIdBase = condIndex != null
		? `xallof-rule-${ruleIndex}-${scope}-${condIndex}`
		: `xallof-rule-${ruleIndex}-${scope}-${missingName}`;

	return (
		<div
			className="dsv-xallof-builder__ghost-row"
			role="group"
			aria-label={`Dangling reference to ${missingName}`}
			data-testid={`${testIdBase}-ghost`}
		>
			<span className="dsv-xallof-builder__ghost-label">
				Field <code>{missingName}</code> no longer exists.
			</span>
			<select
				className="dsv-modal__select"
				value={picker}
				onChange={(e) => setPicker(e.target.value)}
				data-testid={`${testIdBase}-replace-picker`}
			>
				<option value="">Replace with...</option>
				{compatibleFields.map((f) => {
					// Back-compat: earlier callers passed entries with dataElementName;
					// Phase 1b passes addressable entries with displayPath.
					const key = f.displayPath || f.dataElementName;
					return (
						<option key={key} value={key}>
							{key}
						</option>
					);
				})}
			</select>
			<button
				type="button"
				className="dsv-btn dsv-btn--secondary dsv-btn--sm"
				disabled={!picker}
				onClick={() => {
					if (picker) onReplace(picker);
				}}
				data-testid={`${testIdBase}-replace`}
			>
				Replace
			</button>
			<button
				type="button"
				className="dsv-btn dsv-btn--danger dsv-btn--sm"
				onClick={onRemove}
				data-testid={`${testIdBase}-remove`}
			>
				Remove
			</button>
		</div>
	);
}

DanglingRefRow.propTypes = {
	scope: PropTypes.string.isRequired,
	ruleIndex: PropTypes.number.isRequired,
	condIndex: PropTypes.number,
	missingName: PropTypes.string.isRequired,
	compatibleFields: PropTypes.array.isRequired,
	onReplace: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
};
